import React, { useState } from 'react';
import "./page.css";

// Importing images for feature 
import f0 from '../logo/feature0.png'
import f1 from '../logo/feature1.png'
import f2 from '../logo/feature2.png'
import f3 from '../logo/feature3.png'
import f4 from '../logo/feature4.png'
import f5 from '../logo/feature5.png'
import f6 from '../logo/feature6.png'
import f7 from '../logo/feature7.png'

// Importing images for Poney details
import banner from '../logo/banner.png'
import archiImg from '../logo/architectureHoplab.png'
import pinkie from '../logo/pinkipie.png'
import rainbow from '../logo/rainbow.png'
import twilight from '../logo/twilight.png'
import applejack from '../logo/applejack.png'
import fluttershy from '../logo/fluttershy.png'
import rarity from '../logo/rarity.png'
import sweetie from '../logo/sweetie.png'

// Functional component definition for Home page
const Home = () => {
    // Defining all the const here
    const [rotatingPonies, setRotatingPonies] = useState([]);

    const handleLogoClick = (index) => {
        setRotatingPonies(prevState => [...prevState, index]);
        setTimeout(() => {
            setRotatingPonies(prevState => prevState.filter(i => i !== index));
        }, 2000);
    };

    const subtitles = {
        keyFeatures: "Key Features of PoneyPot",
        architecture: "Architecture of PoneyPot",
        poneyDetails: "Poneys in detail"
    };

    const paraText1 = (
        <>
            PoneyPot is a project of honeypot. 
            <br />
            </>
    );

    const paraText2 = (
        <>
            <em>“A honeypot is security resource whose value lies in being probed, attacked, or compromised”.</em> 
            <br />
        </>
    );

    const paraText3 = (
        <>
            The aim of the project is to collect recent and real dataset (network and system) to better understand behavior of attackers.
        </>
    );
    

    const features = [
        { title: "Automatic Deployment",
            description: "Referring to URSID.",
            imgSrc: f0 },
        { title: "Authentic Botnet Attacks", 
            description: "Unlike simulations, PoneyPot captures genuine botnet attacks to ensure the dataset's realism and reliability.", 
            imgSrc: f1 },
        { title: "Extensive Network Traffic", 
            description: "We gather unknown traffic from large networks, ensuring a diverse and comprehensive dataset.",
            imgSrc: f2 },
        { title: "Ground-Truth Labels", 
            description: "Every data point has a label, facilitating more effective training and evaluation of security systems.",
            imgSrc: f3 },
        { title: "Variety of Botnets", 
            description: "Our dataset includes multiple types of botnets, presenting a broad spectrum of attack vectors and techniques.",
            imgSrc: f4 },
        { title: "Synchronization Patterns", 
            description: "By infecting multiple bots simultaneously, we capture crucial synchronization patterns, enhancing the understanding of coordinated attacks.",
            imgSrc: f5 },
        { title: "Detailed Metadata", 
            description: "Relevant data, including time and location, is collected to support in-depth analysis and research.",
            imgSrc: f6 },
        { title: "Privacy Preservation", 
            description: "NetFlow files protect user privacy while collecting detailed network data.",
            imgSrc: f7 },
    ];

    const architectureText = (
        <>
            PoneyPot relies on the infrastructure of {" "}
            <a
                className="page-link-hover"
                href="https://www.inria.fr/fr/hoplab-cybersecurite"
                target="_blank"
                rel="noopener noreferrer"
                data-tooltip="HopLab : une ferme à pots de miel haute interaction"                
            >
                HopLab
            </a> hosted in the {" "}
            <a
                className="page-link"
                href="https://www.lhs-rennes.fr/"
                target="_blank"
                rel="noopener noreferrer"
            >
                LHS
            </a> of Rennes. {" "}
            This architecture supports continuous monitoring, data processing, and storage, providing a reliable infrastructure for the project's objectives. {" "}
            Below is an illustration of a Hoplab architecture, used in one of the previous campaigns:
        </>
    );

    const legendFig1 = (
        <>
            Figure 1: Architecture of Hoplab used in one of the previous campaigns.            
        </>
    )

    const legendFig1Acro = (
        <>* {" "}
            <a
                className="page-link"
                href="https://www.lhs-rennes.fr/"
                target="_blank"
                rel="noopener noreferrer"
            >
                LHS Rennes
            </a>{" "} = Laboratoire de Haute Sécurité de Rennes
            <br />
            * {" "} 
            <a
                className="page-link"
                href="https://lhs.loria.fr/"
                target="_blank"
                rel="noopener noreferrer"
            >
                LHS Nancy
            </a>{" "} = Laboratoire de Haute Sécurité de Nancy
        </>
    )

    const detailsPoney = [
        { title: "Pinkie Pie", 
            description: "Weak password SSH", 
            imgSrc: pinkie },
        { title: "Rainbow Dash", 
            description: "Strong password SSH", 
            imgSrc: rainbow },
        { title: "Applejack", 
            description: "Default password/configuration MongoDB", 
            imgSrc: applejack },
        { title: "Twilight Sparkle", 
            description: "Weak password SSH and privilege escalation (generated with URSID))", 
            imgSrc: twilight },
        { title: "Fluttershy", 
            description: (
                <>
                    Weak Password Recovery vulnerability in GitLab CE (
                    <a
                        className="page-link"
                        href="https://www.cve.org/CVERecord?id=CVE-2023-7028"
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        CVE-2023-7028
                    </a>
                    )
                </>
                ),
            imgSrc: fluttershy },
        { title: "Rarity", 
            description: "Web vulnerability (in progress)", 
            imgSrc: rarity },  
        { title: "Sweetie Belle",
            description: "In progress",
            imgSrc: sweetie },          
   ];

    // Rendering the Home page content
    return (

        <div className="page-banner">
            <img src={banner} alt={"Banner"} className="banner" />


        <div className="page-home">           
            <div className="page-item">
                <p>{paraText1}</p>
            </div>
            <div className="page-item">
                <p>{paraText2}</p>
            </div>
            <div className="page-item">
                <p>{paraText3}</p>
            </div>
            <br />
            <br />

            <div className="page-category">
                <h2>{subtitles.keyFeatures}</h2>
                <ul className="page-list">
                    {features.map((features, index) => (
                        <li key={index} className="page-item poney-detail">
                            <img src={features.imgSrc} alt={features.title} className="poney-img" />                            
                            <div className="poney-info">
                                <h3 style={{textDecorationLine:"underline"}}>{features.title}</h3>
                                <p>{features.description}</p>
                            </div>
                        </li>
                    ))}
                </ul>
            </div>
            <br />

            <div className="page-category">
                <h2>{subtitles.architecture}</h2>
                <ul className="page-list">
                    <li className="page-item">
                        <p>{architectureText}</p>
                        <figure className="architecture-container">
                            <img src={archiImg} alt="Hoplab Architecture" className="architecture-img"/>                    
                            <figcaption>{legendFig1}</figcaption>
                            <p className="figcaptionLeft">{legendFig1Acro}</p>
                        </figure>                   
                    </li>
                </ul>
            </div>
            <br />

            <div className="page-category">
                <h2>{subtitles.poneyDetails}</h2>
                <ul className="page-list">
                    {detailsPoney.map((detailsPoney, index) => (
                        <li key={index} className="page-item poney-detail">
                            <img 
                                src={detailsPoney.imgSrc} 
                                alt={detailsPoney.title} 
                                className={`poney-img ${rotatingPonies.includes(index) ? 'rotating' : ''}`} 
                                onClick={() => handleLogoClick(index)} 
                            />                          
                            <div className="poney-info">
                                <h3 style={{textDecorationLine:"underline"}}>{detailsPoney.title}</h3>
                                <p>{detailsPoney.description}</p>
                            </div>
                        </li>
                    ))}
                </ul>
            </div>
            <br />
        </div>

        </div>
    );
};

export default Home; // Exporting the Home component
